import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'tofFriendlyPaymentMethodName' })
export class FriendlyPaymentMethodName implements PipeTransform {
  transform(value: string): any {
    
    switch (value) {
      case 'chequeOnTheDay': {
        return 'Cheque';        
      }
      case 'cashOnTheDay': {
        return 'Cheque';        
      }
      case 'paypal': {
        return 'PayPal'
      }
      case 'payId': {
        return 'Email/Phone Transfer';        
      }
      case 'customInstructions': {
        return 'Custom Instructions';        
      }
      case 'bank': {
        return 'Bank Transfer';        
      }case 'bank2': {
        return 'Bank Transfer';        
      }
      case 'bank3': {
        return 'Bank Transfer';        
      }
      
      default: {
        return value.replace(/(^[a-z])|(\s+[a-z])/g, txt => txt.toUpperCase());
      }
  

    }
  
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/friendlyPaymentMethodString.pipe.ts